import { type ActionType, type UpdateActionTypeRequest, stripInternalActionTypes } from '../actionTypesApi'
import { demoApi } from './db'

export const actionTypesApi = {
	getActionTypes: async (): Promise<ActionType[]> =>
		stripInternalActionTypes(await demoApi.get<ActionType[]>('/v1/action-types')),

	getOrgActionTypes: async (organizationId: string): Promise<{ result: string[] }> =>
		demoApi.getNoTenant<{ result: string[] }>(`/organizations/${encodeURIComponent(organizationId)}/action-types`),
	createActionType: async (actionType: ActionType): Promise<{ result: string }> =>
		demoApi.post('/v1/action-types', actionType),
	updateActionType: async (action: string, actionType: UpdateActionTypeRequest): Promise<{ result: boolean }> =>
		demoApi.put(`/v1/action-types/${encodeURIComponent(action)}`, actionType),
	deleteActionType: async (action: string): Promise<{ result: boolean }> =>
		demoApi.delete(`/v1/action-types/${encodeURIComponent(action)}`),
	deactivateActionType: async (_name: string): Promise<void> => {
		// TODO: Implement deactivateActionType for demo
		return Promise.resolve()
	},
	reactivateActionType: async (_name: string): Promise<void> => {
		// TODO: Implement reactivateActionType for demo
		return Promise.resolve()
	},
}
